/*
 * @Date: 2022-12-08 15:44:13
 * @LastEditTime: 2022-12-08 15:44:14
 * @Description: file content
 */
const PageMixin = {
  props: {
    trigger: {
      type: Boolean,
      default: false,
    },
    detail: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      shouldStartAnimation: false,
    };
  },
  watch: {
    trigger: {
      handler(newVal) {
        if (newVal) {
          this.startAnimation();
        }
      },
    },
  },
  methods: {
    startAnimation() {
      this.shouldStartAnimation = true;
    },
  },
};

export default PageMixin;
